module.exports = __webpack_public_path__ + "img/21.500338ed.jpg";